import { Fragment, useEffect, useRef, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { navigateToLegacyVendorRoute } from '@/lib/legacyNavigation';
import { clearNewComplaintDrafts } from './pages/complaintDataCache';

export const getNewCaseSessionId = (search: string) =>
  new URLSearchParams(search).get('newSession') || '';

export const startNewCaseSession = (path: string) => {
  clearNewComplaintDrafts();
  navigateToLegacyVendorRoute(path, { newSession: globalThis.crypto.randomUUID() });
};

// A new session resets child state even when the destination path stays the same.
export default function NewCaseSession({ children }: { children: ReactNode }) {
  const location = useLocation();
  return <Fragment key={getNewCaseSessionId(location.search)}>{children}</Fragment>;
}

export function useCaseFormActive() {
  const active = useRef(true);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);
  return active;
}
